module.exports = __webpack_public_path__ + "static/media/piper_hello_en.cefbc03f.svg";